module.exports = __webpack_public_path__ + "img/bus-warbe-realtime.32fbd7ea.png";